/**
 * YouTube URL에서 비디오 ID 추출 (다양한 형식 지원)
 */
export function getYouTubeId(url: string | null | undefined): string | null {
  if (!url) return null
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/
  const match = url.match(regExp)
  return match && match[2].length === 11 ? match[2] : null
}
